import { doc, getDoc, updateDoc, serverTimestamp } from "firebase/firestore";
import { database } from "../Firebase";

// ── Types d'abonnement ────────────────────────────────────────────────────────
export const PLANS = {
  FREE:    "free",
  MENSUEL: "spotyflex",
  ANNUEL:  "spotyzen",
};

// ── Vérifie si l'utilisateur a un abonnement actif ───────────────────────────
export const hasActiveSubscription = (user) => {
  if (!user) return false;
  if (user.role === "admin") return true;
  if (!user.abonnement || user.abonnement === PLANS.FREE) return false;
  if (!user.abonnementExpiration) return false;
  return new Date(user.abonnementExpiration) > new Date();
};

// ── Vérifie si l'utilisateur peut vendre ─────────────────────────────────────
export const canSell = (user) => {
  if (!user) return false;
  if (user.role === "admin") return true;
  return hasActiveSubscription(user);
};

// ── Vérifie si l'utilisateur peut réserver ───────────────────────────────────
// Tous les inscrits peuvent réserver
export const canReserve = (user) => {
  if (!user) return false;
  return true;
};

// ── Active un abonnement dans Firestore ───────────────────────────────────────
export const activerAbonnement = async (userId, plan) => {
  const now        = new Date();
  const expiration = new Date();

  if (plan === PLANS.MENSUEL) {
    expiration.setMonth(expiration.getMonth() + 1);
  } else if (plan === PLANS.ANNUEL) {
    expiration.setFullYear(expiration.getFullYear() + 1);
  }

  await updateDoc(doc(database, "users", userId), {
    abonnement:           plan,
    abonnementDebut:      now.toISOString(),
    abonnementExpiration: expiration.toISOString(),
    abonnementActif:      true,
    updatedAt:            serverTimestamp(),
  });

  return { plan, expiration: expiration.toISOString() };
};

// ── Annule un abonnement ──────────────────────────────────────────────────────
export const annulerAbonnement = async (userId) => {
  await updateDoc(doc(database, "users", userId), {
    abonnement:           PLANS.FREE,
    abonnementActif:      false,
    abonnementExpiration: null,
    updatedAt:            serverTimestamp(),
  });
};

// ── Récupère les infos abonnement d'un utilisateur ───────────────────────────
export const getAbonnementInfo = async (userId) => {
  const snap = await getDoc(doc(database, "users", userId));
  if (!snap.exists()) return null;
  const data = snap.data();
  return {
    plan:       data.abonnement || PLANS.FREE,
    actif:      data.abonnementActif || false,
    debut:      data.abonnementDebut || null,
    expiration: data.abonnementExpiration || null,
    jours:      data.abonnementExpiration
      ? Math.ceil((new Date(data.abonnementExpiration) - new Date()) / (1000*60*60*24))
      : 0,
  };
};